export const SandBoxState = {
    SUCCESS: "succeeded",
    FAILED: "failed",
    PENDING: "pending",
    NONE: "none"
}
